import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../App';
import { toast } from 'sonner';
import axios from 'axios';

const UsersPageWorking = () => {
  const { user, API } = useContext(UserContext);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);

  useEffect(() => {
    console.log('UsersPageWorking mounting...');
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      console.log('Loading users...');
      
      const response = await axios.get(`${API}/users?user_role=system_admin`);
      console.log('Users loaded:', response.data.length);
      setAllUsers(response.data || []);
      
    } catch (error) {
      console.error('Error loading users:', error);
      toast.error('Erreur chargement utilisateurs');
      setAllUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const approveUser = async (userId, username, approved) => {
    try {
      if (!userId) {
        toast.error('ID utilisateur manquant');
        return;
      }

      const action = approved ? 'approuver' : 'rejeter';
      const confirmMessage = `${action.toUpperCase()} l'utilisateur "${username}" ?`;
      
      if (!window.confirm(confirmMessage)) return;

      setActionLoading(userId);

      const response = await axios.post(`${API}/users/approve`, {
        user_id: userId,
        approved: approved,
        approved_by: user?.id || 'system'
      });

      if (response.data.no_change) {
        toast.info(response.data.message);
      } else {
        const successMsg = approved ? 
          `✅ ${username} approuvé avec succès !` : 
          `❌ ${username} rejeté`;
        toast.success(successMsg);
      }
      
      loadUsers();
      
    } catch (error) {
      console.error('Approval error:', error);
      
      if (error.response?.status === 403) {
        toast.error('🚫 ' + error.response.data.detail);
      } else if (error.response?.status === 404) {
        toast.error('❌ Utilisateur non trouvé');
      } else {
        toast.error('Erreur lors de l\'action');
      }
    } finally {
      setActionLoading(null);
    }
  };

  const deleteUser = async (userId, username) => {
    try {
      if (!window.confirm(`SUPPRIMER "${username.toUpperCase()}" ?\n\nCette action est IRRÉVERSIBLE !`)) {
        return;
      }

      setActionLoading(userId);

      await axios.delete(`${API}/users/${userId}?admin_role=system_admin`);
      toast.success(`Utilisateur "${username}" supprimé !`);
      
      loadUsers();
      
    } catch (error) {
      console.error('Delete error:', error);
      toast.error(error.response?.data?.detail || 'Erreur suppression');
    } finally {
      setActionLoading(null);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #fed7aa, #fef3c7)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '80px', 
            height: '80px', 
            border: '8px solid #f97316', 
            borderTop: '8px solid transparent', 
            borderRadius: '50%', 
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <h1 style={{ fontSize: '24px', color: '#dc2626', fontWeight: 'bold' }}>
            🔄 Chargement des Utilisateurs...
          </h1>
          <style dangerouslySetInnerHTML={{
            __html: `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`
          }} />
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #fed7aa 0%, #fef3c7 50%, #fde68a 100%)',
      fontFamily: 'Arial, sans-serif',
      padding: '20px 0'
    }}>
      {/* Navigation Header */}
      <div style={{ 
        background: 'rgba(31, 41, 55, 0.95)', 
        color: 'white', 
        padding: '20px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
        borderBottom: '4px solid #f97316',
        marginBottom: '30px'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold' }}>
              👥 GESTION DES UTILISATEURS
            </h1>
            <p style={{ margin: '8px 0 0 0', fontSize: '16px', opacity: 0.8 }}>
              {allUsers.length} utilisateur(s) dans le système
            </p>
          </div>
          
          <div style={{ display: 'flex', gap: '12px' }}>
            <a href="/dashboard" style={{ 
              padding: '12px 20px', 
              background: '#3b82f6', 
              color: 'white', 
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              🏠 Dashboard
            </a>
            <a href="/users/pending" style={{ 
              padding: '12px 20px', 
              background: '#f97316', 
              color: 'white', 
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold'
            }}>
              📋 Approbations
            </a>
            <button 
              onClick={loadUsers}
              style={{ 
                padding: '12px 20px', 
                background: '#10b981', 
                color: 'white', 
                border: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              🔄 Actualiser
            </button>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 20px' }}>
        
        {/* Statistiques */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '20px',
          marginBottom: '40px'
        }}>
          {[
            { title: 'TOTAL', value: allUsers.length, color: '#3b82f6', bg: '#dbeafe' },
            { title: 'APPROUVÉS', value: allUsers.filter(u => u.approved).length, color: '#10b981', bg: '#d1fae5' },
            { title: 'EN ATTENTE', value: allUsers.filter(u => !u.approved).length, color: '#f59e0b', bg: '#fef3c7' },
            { title: 'ADMIN SYSTÈME', value: allUsers.filter(u => u.role === 'system_admin').length, color: '#dc2626', bg: '#fee2e2' }
          ].map((stat, index) => (
            <div key={index} style={{ 
              background: stat.bg,
              border: `3px solid ${stat.color}`,
              padding: '20px', 
              borderRadius: '16px', 
              textAlign: 'center',
              boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
            }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold', color: stat.color }}>
                {stat.value}
              </div>
              <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#374151' }}>
                {stat.title}
              </div>
            </div>
          ))}
        </div>

        {/* Liste des utilisateurs */}
        {allUsers.length > 0 ? (
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
            gap: '24px' 
          }}>
            {allUsers.map((userItem) => (
              <div key={userItem.id} style={{
                background: 'white',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                border: `3px solid ${
                  userItem.role === 'system_admin' ? '#dc2626' :
                  userItem.role === 'owner' ? '#7c3aed' :
                  userItem.role === 'manager' ? '#2563eb' : '#16a34a'
                }`
              }}>
                {/* Header utilisateur */}
                <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: userItem.role === 'system_admin' ? 
                      'linear-gradient(135deg, #dc2626, #b91c1c)' :
                      userItem.role === 'owner' ? 
                      'linear-gradient(135deg, #7c3aed, #6d28d9)' :
                      userItem.role === 'manager' ? 
                      'linear-gradient(135deg, #2563eb, #1d4ed8)' :
                      'linear-gradient(135deg, #16a34a, #15803d)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 16px auto',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                  }}>
                    <span style={{ 
                      color: 'white', 
                      fontSize: '32px', 
                      fontWeight: 'bold'
                    }}>
                      {userItem.username.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  
                  <h2 style={{ 
                    fontSize: '20px', 
                    fontWeight: 'bold', 
                    color: '#111827',
                    margin: '0 0 8px 0'
                  }}>
                    {userItem.username}
                  </h2>
                  
                  <div style={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    background: userItem.role === 'system_admin' ? '#fee2e2' :
                               userItem.role === 'owner' ? '#ede9fe' :
                               userItem.role === 'manager' ? '#dbeafe' : '#dcfce7',
                    color: userItem.role === 'system_admin' ? '#dc2626' :
                           userItem.role === 'owner' ? '#7c3aed' :
                           userItem.role === 'manager' ? '#2563eb' : '#16a34a',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    border: '2px solid',
                    borderColor: userItem.role === 'system_admin' ? '#dc2626' :
                                userItem.role === 'owner' ? '#7c3aed' :
                                userItem.role === 'manager' ? '#2563eb' : '#16a34a',
                    marginBottom: '12px'
                  }}>
                    {userItem.role.toUpperCase()}
                  </div>

                  <div style={{
                    display: 'block',
                    padding: '6px 12px',
                    background: userItem.approved ? '#d1fae5' : '#fed7d7',
                    color: userItem.approved ? '#065f46' : '#991b1b',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    {userItem.approved ? '✅ APPROUVÉ' : '⏳ EN ATTENTE'}
                  </div>
                </div>

                {/* Informations */}
                <div style={{ 
                  background: '#f9fafb', 
                  padding: '16px', 
                  borderRadius: '12px',
                  marginBottom: '20px',
                  fontSize: '14px'
                }}>
                  <div style={{ marginBottom: '8px' }}>
                    <strong>📅 Créé le:</strong> {userItem.created_at ? new Date(userItem.created_at).toLocaleDateString('fr-FR') : 'N/A'}
                  </div>
                  {userItem.approved_at && (
                    <div style={{ marginBottom: '8px', color: '#065f46' }}>
                      <strong>✅ Approuvé le:</strong> {new Date(userItem.approved_at).toLocaleDateString('fr-FR')}
                    </div>
                  )}
                  <div style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>
                    <strong>ID:</strong> {userItem.id}
                  </div>
                </div>

                {/* Actions d'approbation */}
                {!userItem.approved ? (
                  <div style={{ 
                    background: '#fef3c7', 
                    padding: '16px', 
                    borderRadius: '12px',
                    border: '2px dashed #f59e0b',
                    marginBottom: '16px'
                  }}>
                    <h4 style={{ 
                      margin: '0 0 12px 0', 
                      color: '#92400e', 
                      fontWeight: 'bold',
                      textAlign: 'center'
                    }}>
                      ⚠️ APPROBATION REQUISE
                    </h4>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        onClick={() => approveUser(userItem.id, userItem.username, true)}
                        disabled={actionLoading === userItem.id}
                        style={{
                          flex: 1,
                          padding: '12px',
                          background: actionLoading === userItem.id ? '#9ca3af' : '#16a34a',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          cursor: actionLoading === userItem.id ? 'wait' : 'pointer'
                        }}
                      >
                        {actionLoading === userItem.id ? '⏳ En cours...' : '✅ APPROUVER'}
                      </button>
                      <button
                        onClick={() => approveUser(userItem.id, userItem.username, false)}
                        disabled={actionLoading === userItem.id}
                        style={{
                          flex: 1,
                          padding: '12px',
                          background: actionLoading === userItem.id ? '#9ca3af' : '#dc2626',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          cursor: actionLoading === userItem.id ? 'wait' : 'pointer'
                        }}
                      >
                        {actionLoading === userItem.id ? '⏳ En cours...' : '❌ REJETER'}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{ 
                    background: '#ecfdf5', 
                    padding: '12px', 
                    borderRadius: '8px',
                    border: '2px solid #10b981',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    <span style={{ color: '#065f46', fontWeight: 'bold' }}>
                      ✅ UTILISATEUR VALIDÉ
                    </span>
                  </div>
                )}

                {/* Actions de gestion */}
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => {
                      const newUsername = prompt('Nouveau nom:', userItem.username);
                      if (newUsername && newUsername !== userItem.username) {
                        setActionLoading(userItem.id);
                        axios.put(`${API}/users/${userItem.id}?admin_role=system_admin`, {
                          username: newUsername,
                          role: userItem.role,
                          approved: userItem.approved
                        }).then(() => {
                          toast.success('Nom modifié !');
                          loadUsers();
                        }).catch(err => {
                          toast.error('Erreur modification');
                        }).finally(() => {
                          setActionLoading(null);
                        });
                      }
                    }}
                    disabled={actionLoading === userItem.id}
                    style={{
                      flex: 1,
                      padding: '10px',
                      background: actionLoading === userItem.id ? '#9ca3af' : '#f59e0b',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '13px',
                      fontWeight: 'bold',
                      cursor: actionLoading === userItem.id ? 'wait' : 'pointer'
                    }}
                  >
                    {actionLoading === userItem.id ? '⏳' : '✏️ MODIFIER'}
                  </button>
                  
                  {userItem.id !== user?.id && userItem.role !== 'system_admin' && (
                    <button
                      onClick={() => deleteUser(userItem.id, userItem.username)}
                      disabled={actionLoading === userItem.id}
                      style={{
                        flex: 1,
                        padding: '10px',
                        background: actionLoading === userItem.id ? '#9ca3af' : '#dc2626',
                        color: 'white',
                        border: 'none',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontWeight: 'bold',
                        cursor: actionLoading === userItem.id ? 'wait' : 'pointer'
                      }}
                    >
                      {actionLoading === userItem.id ? '⏳' : '🗑️ SUPPRIMER'}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ 
            textAlign: 'center', 
            padding: '60px',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 12px 24px rgba(0,0,0,0.1)'
          }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>👥</div>
            <h2 style={{ fontSize: '24px', color: '#dc2626', marginBottom: '16px' }}>
              Aucun utilisateur trouvé
            </h2>
            <button 
              onClick={loadUsers}
              style={{ 
                padding: '15px 30px', 
                background: '#3b82f6', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              🔄 Recharger
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UsersPageWorking;